export default __webpack_public_path__ + "media/images/header-logo-2a7e923c08b314ed0fb968b1967feccc.svg";